export default __webpack_public_path__ + "static/media/NOKO_3.c688a7c7.gif";